(() => {
  const initialized = new WeakSet();
  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const cleanup = [];
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const videos = [...root.querySelectorAll('video[data-src]')];
    const visible = new Set();
    const play = video => {
      if (motion.matches || document.hidden || !visible.has(video)) { video.pause(); return; }
      if (!video.hasAttribute('src')) { video.src = video.dataset.src; video.load(); }
      video.muted = true;
      const promise = video.play();
      if (promise) promise.catch(() => {});
    };
    const sync = () => videos.forEach(play);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio > .05) visible.add(entry.target);
          else visible.delete(entry.target);
          play(entry.target);
        }
      }, { threshold: [0, .05, .15] });
      videos.forEach(video => observer.observe(video));
      cleanup.push(() => observer.disconnect());
    } else {
      videos.filter(v => v.getClientRects().length).forEach(v => visible.add(v));
      sync();
    }
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', sync);
    cleanup.push(() => { document.removeEventListener('visibilitychange', sync); motion.removeEventListener('change', sync); videos.forEach(v => v.pause()); });
    root.querySelectorAll('[data-destination]').forEach(element => {
      const navigate = event => {
        const nested = event.target.closest('a,button,[data-destination]');
        if (nested !== element || (event.type === 'keydown' && event.key !== 'Enter')) return;
        location.assign(element.dataset.destination);
      };
      element.addEventListener('click', navigate);
      element.addEventListener('keydown', navigate);
    });
    root.cleanupNativePage = () => cleanup.forEach(fn => fn());
  }
  const scan = node => { if (node.matches?.('.tg6-page')) init(node); node.querySelectorAll?.('.tg6-page').forEach(init); };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.tg6-page').forEach(root => root.cleanupNativePage?.()));
})();
